<template>
  <div class="">
        <div class="sidebar">
            <a href="" @click.prevent="goTop"></a>
            <div>
                <span>咨询<br/>·<br/>反馈</span>
            </div>
        </div>
  </div>
</template>

<script>
export default {
  name: '',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  components:{},
  computed:{},
  methods:{
    //   返回顶部
      goTop(){
          var timer = setInterval(()=>{          
                let scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
                let top=scrollTop/5;                             
              if(scrollTop == 0){
                  console.log("over");
                  clearInterval(timer);
              }
              window.scrollTo(0,scrollTop-top);
          },20)
      }
  },
  mounted:function(){}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
    .sidebar{
        position:fixed;
        right:0;
        top:60%;
        width:40px;
        z-index:100;
        & >a{
            display:inline-block;
            width:40px;
            height:36px;
            background:url(../../../static/img/rightNav_top.png) 50% no-repeat;
            background-color:#7a7a7a;
        }

        & >div{
            background:url(../../../static/img/rightNav_qq.png) 50% 10px no-repeat;
            background-color:#fff;
            border:1px solid #d3e0d5;
            white-space:wrap;
            min-width:40px;
            text-align:center;
            // margin-left:-1px;
            padding:38px 0 10px;

            & >span{
                display:block;
                position:relative;
                left:0;
                right:0;
                margin:0 auto;
                width:1.5em;
                
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/sidebar/sidebar.vue